import { useTranslation } from 'react-i18next'

import Button, { BUTTON_HEIGHT_24 } from '../../Button'

import { QA_NAME_DOC_FLOW_EPOST_VALIDATION_ERRORS_REPORT_BUTTON } from './DocFlowEpostValidationErrorsReportButton.constants'

import * as styles from './DocFlowEpostValidationErrorsReportButton.module.css'

import ErrorIcon from '../../../icons/error.svg'

function DocFlowEpostValidationErrorsReportButton({ onClick, ...restProps }) {
  const { t } = useTranslation()

  return (
    <Button.Icon
      {...restProps}
      Icon={ErrorIcon}
      className={styles.DocFlowEpostValidationErrorsReportButton}
      height={BUTTON_HEIGHT_24}
      qaName={QA_NAME_DOC_FLOW_EPOST_VALIDATION_ERRORS_REPORT_BUTTON}
      tooltip={t('DocFlow.EpostValidationErrorsOpenReportBtnKey')}
      onClick={onClick}
    />
  )
}

export default DocFlowEpostValidationErrorsReportButton
